/*
  Add Custom JS to be layered on top of ciritical theme js
  Events
  
  product:init
  product:variantSelected

  cart:itemAdding
  cart:itemAdded
  cart:updated
  cart:error

  cart:cartOfferComplete

  modal:show
  modal:hide

*/


document.addEventListener("product:init", () => {
  setTimeout(() => {
    window.dispatchEvent(new Event("variantExtendLoaded", { detail: { variant: Neptune.products[0].variant.id } }));
  }, 50);
});


document.addEventListener("product:variantSelected", () => {
  window.dispatchEvent(new Event("variantExtendChange", { detail: { variant:_n.qs("[neptune-product]").variant } }))
})


/*
  Do NOT initCart on every cart:updated — that + Extend normalize/refreshCart
  caused 10–15× /cart.js on PDP load (429 / ATC fail).
  Only re-sync Extend after real add / offer / drawer open.
*/
function syDispatchInitCart() {
  if (window.__extendSuppressInitCart) return;
  clearTimeout(window.__syInitCartTimer);
  window.__syInitCartTimer = setTimeout(function () {
    if (window.__extendSuppressInitCart) return;
    window.dispatchEvent(new Event('initCart'));
  }, 400);
}

document.addEventListener("cart:itemAdded", function () {
  syDispatchInitCart();
});

document.addEventListener("cart:cartOfferComplete", function () {
  syDispatchInitCart();
});

document.addEventListener("modal:show", function (event) {
  if(event.detail.info=='cart'){
    window.dispatchEvent(new Event('sideCartOpen'))
  }
})
